// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Keep existing CSS import

// --- Supabase & Auth Setup ---
import './supabaseClient'; // Initialize Supabase client
import './api/auth';       // Initialize auth service (if it has side effects)

// --- Axios Interceptor Setup ---
import './api/axiosConfig'; // <<<--- THIS LINE WAS ALREADY PRESENT AND CORRECT

// --- Main App Component ---
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();